import { render, staticRenderFns } from "./ProductBox.vue?vue&type=template&id=e66c6210&scoped=true"
import script from "./ProductBox.vue?vue&type=script&lang=js"
export * from "./ProductBox.vue?vue&type=script&lang=js"
import style0 from "./ProductBox.vue?vue&type=style&index=0&id=e66c6210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66c6210",
  null
  
)

export default component.exports